import S from './Logo.module.scss';

export const logoSizeClassNames = {
  default: S.logo_default,
  small: S.logo_small,
  bg: S.logo_bg,
};

export const logoColorClassNames = {
  white: S.color_white,
  grey: S.color_grey,
};
